import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiRequests from "../../../Component/axios/config/config";
import Loading from "../../../Component/Loading/Loading";
import { Pencil } from "lucide-react";
import { MdArrowBack } from "react-icons/md";
import Dropdown from "../../../Component/Dropdown/Drowdown";
import toast from "react-hot-toast";

export default function AdminProductDetails() {
  const { id, type } = useParams();

  const navigate = useNavigate();

  const [update, setUpdate] = useState(false);

  const [product, setProduct] = useState(null);

  const [loading, setLoading] = useState(true);
  const [loadingImage, setLoadingImage] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);

  const [showModalCategory, setShowModalCategory] = useState(false);
  const [CategoryListData, setCategoryListData] = useState([]);

  const [showModalNationality, setShowModalNationality] = useState(false);
  const [NationalityListData, setNationalityListData] = useState([]);

  // for edit value
  const [Name, setName] = useState("");
  const [Description, setDescription] = useState("");
  const [Price, setPrice] = useState(0);
  const [Category, setCategory] = useState({
    id: "",
    name: "",
  });

  // food-only fields
  const [Tastes, setTastes] = useState("");
  const [Calorie, setCalorie] = useState(0);
  const [Stock, setStock] = useState(0);
  const [Nationality, setNationality] = useState({
    id: "",
    name: "",
  });

  // image product
  const [imageUrl, setImageUrl] = useState("");
  const [imageID, setImageID] = useState([]);

  const isFood = type === "order";

  useEffect(() => {
    setLoading(true);
    apiRequests
      .get(`/api/product/get-single/${id}`)
      .then((response) => {
        const data = response.data.data;
        setProduct(data);
        setName(data.name);
        setDescription(data.description);
        setCategory({
          id: data.category._id,
          name: data.category.name,
        });
        setPrice(data.price);
        setImageUrl(`${process.env.REACT_APP_API_URL}${data.images[0].path}`);
        setImageID([data.images[0]._id]);

        if (data.Type === "FOOD") {
          setTastes(data.tastes?.join(", ") || "");
          setCalorie(data.calorie || 0);
          setStock(data.stock || 0);
          setNationality({
            id: data.nationality?._id || "",
            name: data.nationality?.name || "",
          });
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [id, update]);

  useEffect(() => {
    const endpoint = isFood
      ? "/api/category/get-all-Food-admin"
      : "/api/category/get-all-admin";

    apiRequests
      .get(endpoint)
      .then((res) => {
        setCategoryListData(res.data.data.docs);
      })
      .catch(() => {})
      .finally(() => {});
  }, [type]);

  useEffect(() => {
    if (!isFood) return;

    apiRequests
      .get("/api/nationality/v1/get-all-nationality-admin")
      .then((res) => {
        setNationalityListData(res.data.data);
      })
      .catch(() => {});
  }, [type]);

  const toggleStatus = () => {};

  function readImage() {
    document.querySelector("#profile")?.click();
  }

  function UploadImage(e) {
    const formData = new FormData();
    formData.append("file", e.target.files[0]);

    setLoadingImage(true);
    apiRequests
      .post(`/api/file/v1/upload-admin`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setImageUrl(URL.createObjectURL(e.target.files[0]));
        setImageID([...imageID, response.data.message._id]);
      })
      .catch((err) => {})
      .finally(() => {
        setLoadingImage(false);
      });
  }

  function EditProduct() {
    setLoadingEdit(true);

    const baseData = {
      id: id,
      name: Name,
      price: Price,
      description: Description,
      images: imageID,
      category: Category.id,
    };

    const data = isFood
      ? {
          ...baseData,
          tastes: Tastes.split(",")
            .map((t) => t.trim())
            .filter(Boolean),
          calorie: Calorie,
          stock: Stock,
          nationality: Nationality.id,
        }
      : baseData;

    const endpoint = isFood
      ? "/api/product/update-admin-food"
      : "/api/product/update-admin-product";

    apiRequests
      .patch(endpoint, data)
      .then(() => {
        toast.success("successfully updated product!");
        setUpdate(!update);
      })
      .catch(() => {})
      .finally(() => setLoadingEdit(false));
  }

  if (loading)
    return (
      <div className="p-12">
        <Loading />
      </div>
    );
  if (!product)
    return (
      <div className="text-center font-bold text-xl text-gray-500 mt-20">
        Product not found
      </div>
    );

  return (
    <div className="max-w-6xl mx-auto">
      <div className="flex flex-col sm:flex-row mt-8 justify-between gap-4"></div>

      <div className="bg-white p-6">
        <p className="text-3xl font-bold text-gray-800 mb-6">Edit Product</p>
        <div className="flex flex-col gap-8">
          <div className="p-4 flex flex-col rounded-xl gap-2 border border-gray-200 bg-gray-100">
            <h2 className="text-firstColor-shade9 text-2xl font-bold">Image</h2>
            <div className="rounded-lg p-4 flex items-center gap-5">
              {loadingImage ? (
                <Loading />
              ) : (
                <img
                  src={imageUrl}
                  alt="product"
                  className="w-52 h-52 rounded-full object-cover"
                />
              )}
              {!loadingImage && (
                <div className="w-10 h-10">
                  <input
                    type="file"
                    accept="image/*"
                    onClick={() => readImage()}
                    onChange={UploadImage}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="p-4 flex flex-col rounded-xl gap-2 border border-gray-200 bg-gray-100">
            <h2 className="text-firstColor-shade9 text-2xl font-bold">
              Information
            </h2>

            <div className="grid grid-cols-2 auto-cols-auto gap-5">
              <DetailItem label="exists">
                <span
                  onClick={toggleStatus}
                  className={`cursor-pointer inline-flex items-center px-3 py-1 rounded-full text-sm
                                            ${product.is_exists ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}
                >
                  {product.is_exists ? <>available</> : <>unavailable</>}
                </span>
              </DetailItem>

              <DetailItem label="Name">
                <input
                  className="py-1 pl-2 bg-transparent outline-none w-full"
                  value={Name}
                  onChange={(e) => setName(e.target.value)}
                />
              </DetailItem>

              <DetailItem label="Price">
                <div className="flex items-center">
                  $
                  <input
                    className="py-1 pl-2 bg-transparent outline-none w-full"
                    type="number"
                    value={Price}
                    onChange={(e) => setPrice(parseInt(e.target.value))}
                  />
                </div>
              </DetailItem>

              <DetailItem label="Category">
                <div
                  className="inline-block relative w-full"
                  onClick={() => setShowModalCategory(!showModalCategory)}
                >
                  <input
                    className="py-1 pl-2 bg-transparent outline-none w-full"
                    value={Category.name}
                    readOnly
                    placeholder="enter category"
                  />

                  {showModalCategory && (
                    <Dropdown
                      data={CategoryListData}
                      setOpen={setShowModalCategory}
                      setValue={setCategory}
                    />
                  )}
                </div>
              </DetailItem>

              {isFood && (
                <>
                  <DetailItem label="Calorie">
                    <input
                      className="py-1 pl-2 bg-transparent outline-none w-full"
                      type="number"
                      value={Calorie}
                      onChange={(e) => setCalorie(parseInt(e.target.value))}
                    />
                  </DetailItem>

                  <DetailItem label="Stock">
                    <input
                      className="py-1 pl-2 bg-transparent outline-none w-full"
                      type="number"
                      value={Stock}
                      onChange={(e) => setStock(parseInt(e.target.value))}
                    />
                  </DetailItem>

                  <DetailItem label="Tastes">
                    <input
                      className="py-1 pl-2 bg-transparent outline-none w-full"
                      placeholder="Spicy, Salty"
                      value={Tastes}
                      onChange={(e) => setTastes(e.target.value)}
                    />
                  </DetailItem>

                  <DetailItem label="Nationality">
                    <div
                      className="inline-block relative w-full"
                      onClick={() =>
                        setShowModalNationality(!showModalNationality)
                      }
                    >
                      <input
                        className="py-1 pl-2 bg-transparent outline-none w-full"
                        value={Nationality.name}
                        readOnly
                        placeholder="enter nationality"
                      />

                      {showModalNationality && (
                        <Dropdown
                          data={NationalityListData}
                          setOpen={setShowModalNationality}
                          setValue={setNationality}
                        />
                      )}
                    </div>
                  </DetailItem>
                </>
              )}
            </div>
          </div>

          <div className="p-4 flex flex-col rounded-xl gap-4 border border-gray-200 bg-gray-100">
            <h3 className="text-firstColor-shade9 text-2xl font-bold">
              Description
            </h3>
            <p className="text-gray-600 leading-relaxed  whitespace-pre-line">
              <input
                className="py-1 pl-2 outline-none bg-transparent"
                value={Description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </p>
          </div>

          {product.attributes && Object.keys(product.attributes).length > 0 && (
            <div className="p-4 flex flex-col rounded-xl gap-2 border border-gray-200 bg-gray-100">
              <h3 className="text-firstColor-shade9 text-2xl font-bold">
                Specifications
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {Object.entries(product.attributes).map(([key, value]) => (
                  <div key={key} className="p-3 rounded-lg">
                    <span className="text-sm text-gray-500">{key}</span>
                    <p className="font-medium">{value}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="p-4 flex flex-col rounded-xl gap-2 border border-gray-200 bg-gray-100">
            <div className="grid grid-cols-2 md:grid-cols-2 gap-4 text-sm">
              <div className="p-3 rounded-lg col-span-1">
                <span className="text-gray-500">Created At</span>
                <p className="font-medium">
                  {new Date(product.createdAt).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </p>
              </div>
              <div className="p-3 rounded-lg col-span-1">
                <span className="text-gray-500">Last Updated</span>
                <p className="font-medium">
                  {new Date(product.updatedAt).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </p>
              </div>
              <div className="p-3 rounded-lg col-span-1">
                <span className="text-gray-500">Seller username</span>
                <p>{product.seller.userName}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-2 mt-4">
          <button
            onClick={EditProduct}
            className="flex items-center bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg gap-2"
          >
            {loadingEdit ? (
              <Loading textColor={"white-0"} />
            ) : (
              <>
                <Pencil className="w-4 h-4" />
                Apply
              </>
            )}
          </button>
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-center border-2 hover:bg-black hover:text-white border-black text-baseColor-first px-4 py-2 rounded-lg gap-2"
          >
            <MdArrowBack />
            Back
          </button>
        </div>
      </div>
    </div>
  );
}

const DetailItem = ({ label, children }) => (
  <div className="flex flex-col gap-3 py-2 px-3 rounded-lg">
    <span className="text-gray-900">{label} :</span>
    <div className="text-gray-500">{children}</div>
  </div>
);
